const styles = {
  container: {
    width: "100%",
    margin: "auto",
    px: "5rem",
    py: "3rem",
    display: "grid",
    "@media (max-width: 767px)": {
      padding: ".25rem",
    },
  },
  title: {
    textAlign: "left",
    letterSpacing: "0px",
    color: "#1C5866",
    opacity: 1,
    fontSize: "24px",
  },
  subtitle: {
    textAlign: "left",
    letterSpacing: "0px",
    color: "#1C5866",
    opacity: 1,
    fontSize: "14px",
  },
  description: {
    textAlign: "left",
    letterSpacing: "0px",
    color: "#1C5866",
    opacity: 1,
    fontSize: "12px",
    mb: 5,
  },
  axisLabel: {
    textAlign: "center",
    letterSpacing: "0px",
    fontSize: "14px",
    fontFamily: "Geologica Regular !important",
  },
  yAxisLabel: {
    display: "flex",
    textAlign: "center",
    letterSpacing: "0px",
    fontSize: "14px",
    writingMode: "vertical-lr",
    transform: "rotate(180deg)",
    height: "50%",
    justifyContent: "center",
    width: "0%",
    fontFamily: "Geologica Regular !important",
  },
  footnote: {
    color: "#3B4348",
    fontSize: "10px",
    textAlign: "justify",
    mt: 2,
    fontFamily: "Geologica Bold !important",
  },
};

export default styles;
